import { render, staticRenderFns } from "./DashboardBrand.vue?vue&type=template&id=5ec1df8b&scoped=true&"
import script from "./DashboardBrand.vue?vue&type=script&lang=js&"
export * from "./DashboardBrand.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBrand.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DashboardBrand.vue?vue&type=style&index=1&id=5ec1df8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec1df8b",
  null
  
)

export default component.exports